import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const AdminRoute = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const { activeCompany } = useSelector((state) => state.admin);
    const location = useLocation();

    if (userInfo && userInfo.isAdmin) {
        // If user is Super Admin and trying to access company list, allow it without activeCompany
        if (userInfo.isSuperAdmin && location.pathname === '/admin/companylist') {
            return <Outlet />;
        }

        if (!activeCompany && location.pathname !== '/admin/select-company') {
            return <Navigate to="/admin/select-company" replace />;
        }
        return <Outlet />;
    }

    return <Navigate to="/login" replace />;
};
export default AdminRoute;
